/** Largest file that can be picked, in MB (larger ones are ignored). */
export const MAX_FILE_SIZE_MB = 35;

export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

/** The file types that can be picked (others are ignored). */
export const ALLOWED_FILE_EXTENSIONS = ['.pdf', '.png', '.jpg', '.txt'];
